// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 176 ? "projects" : chunkId) + "." + {"176":"bef66bf6","700":"ffd071fa"}[chunkId] + ".js";
};